import React from "react";

const DispatchContext = React.createContext();
export default DispatchContext;
